export interface LoginInput {
    email: string;
    password: string;
}

export const UserRoles = {
    ADMIN: {
        key: 'ADMIN',
        desc: 'Administrateur'
    },
    SITEMNGR: {
        key: 'SITEMNGR',
        desc: 'Manager de sites'
    },
    USER:{
        key: 'USER',
        desc: 'Utilisateur'
    }
};

